export default "__VITE_ASSET__DYQqlDti__"